var React = require('react');

function DownInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Down Arrow"),React.createElement("path",{"fill":"#fff","d":"M9.293 12.95l0.707 0.707 5.657-5.657-1.414-1.414-4.243 4.242-4.243-4.242-1.414 1.414z","key":1})]);
}

DownInline.defaultProps = {"version":"1.1","width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = DownInline;

DownInline.default = DownInline;
